import { IAccounts, IHolders } from '../../../../../services/response.interface';
import { fnLocalizeFilter, ILocale } from '../../../../../services/localize.service';
import { InterfaceUtils } from './interface.utils';

export const getFormatListAccount = (locale: ILocale, accounts: IAccounts[]) => {
  return [{
    id: 0, accountId: 0, remark: fnLocalizeFilter(locale, '_lang.module.reports.titleAll'),
  }, ...accounts.map(account => ({
    ...account, remark: account.id === -1 ? account.remark : `[${account.id}] ${account.remark}`,
  }))];
};


export const getHolderIdFromParams = (params: InterfaceUtils, holders: IHolders[]) => {
  if (params?.holderId !== undefined && parseInt(params.holderId) !== 0) {
    return parseInt(params.holderId);
  }

  if (holders.length > 0) {
    return holders[0].holderId;
  }

  return 0;
};

export const getAccountIdFromParams = (params: InterfaceUtils) => {
  if (params?.accountId !== undefined && parseInt(params.accountId) !== 0)
    return parseInt(params.accountId);
  else return 0;
};

export const getCurrentAccountIdFromParams = (params: InterfaceUtils) => {
  if (params?.currentAccount !== undefined && parseInt(params.currentAccount) !== 0)
    return parseInt(params.currentAccount);
  else return 0;
};
